import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface ConnectivityHeatmapSlot {
  time: string;
  delay: boolean;
  power: unknown[];
}

export interface ConnectivityHeatmapDay {
  day: string;
  date: string;
  slots: ConnectivityHeatmapSlot[];
}

export interface ConnectivityHeatmapParams {
  unitId: string | number;
  from: string;
  to: string;
}

export const getConnectivityHeatmap = (
  params: ConnectivityHeatmapParams,
  language?: string,
) =>
  ApiService.get<{ response: ConnectivityHeatmapDay[] }>(
    `${ServicesUrlEndpoints.CONNECTIVITY_HEATMAP}/${params.unitId}`,
    {
      ...getLanguageHeaders(language),
      params: {
        from: params.from,
        to: params.to,
      },
    },
  );
